// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__MRgh3","requiredAsterisk":"Info_requiredAsterisk__2e1Wt"};